<template>
  <div>
    <header-page :image="18">
      <h1>{{ $t('views.e-appeal.title') }}</h1>
    </header-page>
    <div class="app-container body-page">
      <div class="row">
        <!-- <div class="col-lg-5 col-12 mb-lg-0 mb-5">
          <form-appeal></form-appeal>
        </div> -->
        <div class="col-lg-8 col-12">
          <p>
            {{ $t('views.e-appeal.shortDescription.start') }}
            <a
              href="https://pravo.by/document/?guid=3871&p0=h11100300"
              target="_blank"
              style="color: #1461ff"
            >
              {{ $t('views.e-appeal.shortDescription.npaLink') }}
            </a>
            {{ $t('views.e-appeal.shortDescription.part2') }}
          </p>
          <p>
            {{ $t('views.e-appeal.shortDescription.part3') }}
            <a
              href="https://xn--80abnmycp7evc.xn--90ais/"
              target="_blank"
              style="color: #1461ff"
              >https://обращения.бел</a
            >
            {{ $t('views.e-appeal.shortDescription.end') }}
          </p>
          <!-- <description></description> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage';
// import FormAppeal from './components/FormAppeal';
// import Description from './components/Description';

export default {
  name: 'ElectronicAppeal',
  components: {
    HeaderPage,
    // FormAppeal,
    // Description,
  },
};
</script>

<style lang="stylus" scoped>
.body-page {
  margin-top: 50px;
  margin-bottom: 50px;
}
</style>
